export const labels = {
	bold: {
		label: "Label.MobileCreator.BottomMenu.Text.Style.Bold",
		default: "Bold",
	},
	italic: {
		label: "Label.MobileCreator.BottomMenu.Text.Style.Italic",
		default: "Italic",
	},
	underline: {
		label: "Label.MobileCreator.BottomMenu.Text.Style.Underline",
		default: "Underline",
	},
};
